interface NavButtonsProps {
  onBack?: () => void;
  onNext: () => void;
  canGoBack: boolean;
  canAdvance: boolean;
  nextLabel?: string;
  /** Hint shown next to the button on non-touch devices. */
  showEnterHint?: boolean;
}

export function NavButtons({
  onBack,
  onNext,
  canGoBack,
  canAdvance,
  nextLabel = "Continue",
  showEnterHint = true,
}: NavButtonsProps) {
  return (
    <div className="mt-8 flex items-center gap-3">
      <button
        type="button"
        className="r1-btn-primary"
        onClick={onNext}
        disabled={!canAdvance}
      >
        {nextLabel}
      </button>
      {canGoBack && onBack ? (
        <button type="button" className="r1-btn-ghost" onClick={onBack}>
          Back
        </button>
      ) : null}
      {showEnterHint && canAdvance ? (
        <span className="ml-1 hidden items-center gap-1 text-sm text-ink-muted sm:flex">
          press <kbd className="rounded border border-slate-300 bg-slate-50 px-1.5 py-0.5 text-xs">Enter</kbd>
        </span>
      ) : null}
    </div>
  );
}
